export enum BILLING_STATES {
  ALL_OK,
  MISSING_READING,
  ADJUSTMENT_NECESSARY,
  ADJUSTMENT_NECESSARY_CHANGENOTALLOWED,
  LOWER_RECOMMENDED,
  LOWER_RECOMMENDED_CHANGENOTALLOWED
}
